import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('sortButton');
  return (
    <View style={styles.container}>
      <Icon name="filter" />
      <Text style={styles.text}>{tt('sortBy', 'Sort By ')}</Text>
      <LoadingBox style={styles.loadingBoxSortBy} />
    </View>
  );
};

export default Loading;
